export const INVITATION_PATH = '/invitation';
export const FORGOTTEN_PASSWORD_PATH = '/forgotten-password';
